import { useDispatch, useSelector } from "react-redux";
import { appdataSelector } from "reducers/appdata/appdata";
import { vendordataSelector, vendordata_updateActiveVendor } from "reducers/vendordata/vendordata";
import { formatData } from "./VendordataHelper";
import { Card } from "@mui/material";
import Button from "@mui/material/Button";
import React from "react";
import classnames from "classnames";

function VendordataEditableContact() {
    const vendordata = useSelector(vendordataSelector);
    const appdata = useSelector(appdataSelector);
    const dispatch = useDispatch();
    const inputWidth = "100%";
    const styles = {
        myInput: {
            width: inputWidth
        }
    };

    let datapart = { ...vendordata.vendorParts.CONTACT };
    let data = formatData("CONTACT", datapart, appdata, vendordata,);


    const handleChange = (value, key, id) => {
        console.log("handle change", value, key, id);

        dispatch(
            vendordata_updateActiveVendor({
                part: "CONTACT",
                key: key,
                id: id,
                value: value
            })
        );
    };

    const handleAddContact = () => {
        console.log("handle add contact");
        if (vendordata.activeVendor.CONTACT && Object.keys(vendordata.activeVendor.CONTACT).length > 0) {
            console.log("contacts present, get last seq");
            let lastSeq = parseInt(vendordata.activeVendor.CONTACT[Object.keys(vendordata.activeVendor.CONTACT).length - 1]["SEQ"]);
            let newSeq = lastSeq + 1;
            dispatch(
                vendordata_updateActiveVendor({
                    part: "CONTACT",
                    key: Object.keys(vendordata.activeVendor.CONTACT).length,
                    value: { seq: newSeq }
                })
            );

        }
        else {
            console.error("no contacts present, just add one, can not happen")
        }
    }

    const handleRemoveContact = (SEQ) => {
        console.log("remove contact", SEQ);

        let id = null;
        Object.keys(vendordata.activeVendor.CONTACT).map((key, value) => {
            if (vendordata.activeVendor.CONTACT[key]["SEQ"] == SEQ) {
                id = key;
            }
        });

        if (id)
            handleChange("X", "REMOVE", id);

    }

    // create a card for every single contact
    return (

        <React.Fragment>

            {/* cards with contact */}
            {/* cards with contact */}
            {/* cards with contact */}
            {/* cards with contact */}
            {/* cards with contact */}
            {Object.keys(data).map(key => {
                console.log("render", key, data[key])
                let fields = data[key].item;

                return (

                    <Card className={data[key].DELETED ? "p-4 mt-2 bg-danger" : data[key].REMOVE ? "p-4 mt-2 bg-warning" : "p-4 mt-2"}
                        key={"Card" + key}
                        style={{ pointerEvents: data[key].REMOVE || data[key].DELETED ? "none" : "" }} >
                        {/* header */}
                        {/* header */}
                        {/* header */}
                        {/* header */}
                        <div className="row border-bottom mb-2 pb-2">
                            <div className="col-3 d-none d-md-block">Label</div>
                            <div className="col-6 col-md-4">New value</div>
                            {appdata.activeRequestType != "NV" && (
                                <div className="col-6 col-md-5">Original value</div>
                            )}
                        </div>

                        {/* show fields */}
                        {/* show fields */}
                        {/* show fields */}
                        {/* show fields */}
                        {Object.keys(fields).map(fieldkey => {
                            if (fields[fieldkey].hidden)
                                return



                            let highlightInfo = false;
                            if (appdata.activeRequestType != "NV") {
                                if (fields[fieldkey].active != fields[fieldkey].sap && (fields[fieldkey].active || fields[fieldkey].sap)) {
                                    highlightInfo = true;
                                }
                            }

                            let highlight = false;
                            if (appdata.highlightRequiredFields) {
                                if (vendordata.incompleteRequiredFields.hasOwnProperty("CONTACT") && Object.keys(vendordata.incompleteRequiredFields["CONTACT"]).includes(key)) {
                                    if (vendordata.incompleteRequiredFields.CONTACT[key].includes(fieldkey)) {
                                        console.log("set highglight",key,fieldkey)
                                        highlight = true;
                                    }
                                }
                            }

                            
                            let cls = "row mt-1 mb-1";

                            if (highlight){
                                cls += " border border-danger"
                            }
                            if (!highlight && highlightInfo){
                                cls += " border border-info"
                            }

                            return (
                                <div className={cls} key={"rowpart" + fieldkey} >
                                    <div className="col-3 d-none d-md-flex align-items-center" key={"label" + fieldkey}>
                                        <b>
                                            {fields[fieldkey].label} {fields[fieldkey].required ? "*" : ""}
                                        </b>
                                    </div>
                                    <div className="col-6 col-md-4" key={"active" + fieldkey} >
                                        <input
                                            disabled={false}
                                            style={styles.myInput}
                                            onChange={event => {
                                                handleChange(
                                                    event.target.value,
                                                    fieldkey,
                                                    key
                                                );
                                            }}
                                            /* hidden={hidden} */
                                            key={"input" + fieldkey}
                                            /* id={key} */
                                            type="text"
                                            value={fields[fieldkey].active ? fields[fieldkey].active : ""}
                                        /* maxLength={maxChars ? maxChars : null} */
                                        ></input>

                                    </div>
                                    <div className="col-6 col-md-5 d-flex align-items-center" style={{ textDecoration: highlightInfo ? "line-through" : "" }}>{fields[fieldkey].sap}</div>
                                </div>
                            )
                        })}

                        <div className="text-right w-100">

                            {(data[key].REMOVE || data[key].DELETED) && (
                                <b>This contact {data[key].DELETED ? "has been" : "will be"} removed</b>

                            )}

                            {!data[key].REMOVE && !data[key].DELETED && (


                                <Button
                                    className={classnames("besiButton", "d-print-none")}
                                    variant="contained"
                                    key={key + "removebutton"}
                                    onClick={() => handleRemoveContact(data[key]["SEQ"])}
                                >
                                    remove
                                </Button>
                            )}

                        </div>


                    </Card>)
            })}

            {/* end cards with content */}
            {/* end cards with content */}
            {/* end cards with content */}
            {/* end cards with content */}
            {/* end cards with content */}

            {/* add contact button */}
            {/* add contact button */}
            {/* add contact button */}
            {/* add contact button */}
            {/* add contact button */}

            < div key="addcontact buttondiv" >
                <Button
                    className={classnames("besiButton", "d-print-none", "mt-2")}
                    variant="contained"
                    key="addcontactbutton2"
                    onClick={() => handleAddContact()}
                >
                    Add Contact
                </Button>
            </div >



        </React.Fragment>
    )

}

export default VendordataEditableContact